import React from "react";

import Table from "../../common/Table";

import lbl from "../../../data/Labels.json";

const ResultList = ({ activeSem }) => {
  const renderResult = (e) =>{
      let res = '';
      if(e.result === null) res = '-';
      else if(e.result === 0) res = 'ناکام';
      else if(e.result === 1) res = 'کامیاب';
      else if(e.result === 3) res = 'محروم حاضری';
      else res = e.result;

      return <div className={`result-result-${e.result}`}>{res}</div>
  }

  const renderChance = (e) =>{
      return (
          <div className={'result-chances'}>
              {e.chance_no >= 1 && <div>1</div>}
              {e.chance_no >= 2 && <div>2</div>}
              {e.chance_no >= 3 && <div>3</div>}
              {e.chance_no >= 4 && <div>4</div>}
          </div>
      )
  }

  const paymentsColumn = [
    { path: "id", label: "شماره" },
    { path: "chance_no", label: "چانس",    content: (e) => renderChance(e) },
    { path: "subject_name", label: "مضمون", content: (e) => <b>{e.subject_name}</b> },
    { path: "mid_term", label: "بیست فیصد" },
    { path: "class_activity", label: "فعالیت صنفی" },
    { path: "homework", label: "کار خانگی" },
    { path: "final", label: "نهایی" },
    { path: "total", label: "مجموعه" },
    { path: "grade", label: "درجه بندی" },
    { path: "result", label: "نتیجه" , content: (e) => renderResult(e)},
  ];

  return (
    <div className="table-card">
      <p className="table-title">{lbl.ListOfSubjects}</p>
      <Table
        data={activeSem?.subjects}
        columns={paymentsColumn}
      />
    </div>
  );
};

export default ResultList;
